export default "__VITE_ASSET__BPiGkvnz__"